module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/ChevronUp.5468c749.svg";